
import p1_1 from '../images/products/id1/id1-1.png';
import p1_2 from '../images/products/id1/id1-2.png';
import p1_3 from '../images/products/id1/id1-3.png';
import p1_4 from '../images/products/id1/id1-4.png';

import p2_1 from '../images/products/id2/id-2-1.png';
import p2_2 from '../images/products/id2/id2-2.png';
import p2_3 from '../images/products/id2/id2-3.png';

import p3_1 from '../images/products/id3/id3-1.png';
import p3_2 from '../images/products/id3/id3-2.png';
import p3_3 from '../images/products/id3/id3-3.png';

import p4_1 from '../images/products/id4/id4-1.png';
import p4_2 from '../images/products/id4/id4-2.png';
import p4_3 from '../images/products/id4/id4-3.png';

import p5_1 from '../images/products/id5/id5-1.png';
import p5_2 from '../images/products/id5/id5-2.png';
import p5_3 from '../images/products/id5/id5-3.png';

import p6_1 from '../images/products/id6/id6-1.png';
import p6_2 from '../images/products/id6/id6-2.png';
import p6_3 from '../images/products/id6/id6-3.png';

import p7_1 from '../images/products/id7/id7-1.png';
import p7_2 from '../images/products/id7/id7-2.png';
import p7_3 from '../images/products/id7/id7-3.png';

import p8_1 from '../images/products/id8/id8-1.png';
import p8_2 from '../images/products/id8/id8-2.png';
import p8_3 from '../images/products/id8/id8-3.png';

import p9_1 from '../images/products/id9/id9-1.png';
import p9_2 from '../images/products/id9/id9-2.png';
import p9_3 from '../images/products/id9/id9-3.png';

import p10_1 from '../images/products/id10/id10-1.png';
import p10_2 from '../images/products/id10/id10-2.png';
import p10_3 from '../images/products/id10/id10-3.png';

import p11_1 from '../images/products/id11/id11-1.png';
import p11_2 from '../images/products/id11/id11-2.png';
import p11_3 from '../images/products/id11/id11-3.png';
import p11_4 from '../images/products/id11/id11-4.png';

import p12_1 from '../images/products/id12/id12-1.png';
import p12_2 from '../images/products/id12/id12-2.png';
import p12_3 from '../images/products/id12/id12-3.png';
import p12_4 from '../images/products/id12/id12-4.png';

import p13_1 from '../images/products/id13/id13-1.png';
import p13_2 from '../images/products/id13/id13-2.png';
import p13_3 from '../images/products/id13/id13-3.png';
import p13_4 from '../images/products/id13/id13-4.png';

import p14_1 from '../images/products/id14/id14-1.png';
import p14_2 from '../images/products/id14/id14-2.png';
import p14_3 from '../images/products/id14/id14-3.png';
import p14_4 from '../images/products/id14/id14-4.png';

import p15_1 from '../images/products/id15/id15-1.png';
import p15_2 from '../images/products/id15/id15-2.png';
import p15_3 from '../images/products/id15/id15-3.png';
import p15_4 from '../images/products/id15/id15-4.png';

import p16_1 from '../images/products/id16/id16-1.png';
import p16_2 from '../images/products/id16/id16-2.png';
import p16_3 from '../images/products/id16/id16-3.png';
import p16_4 from '../images/products/id16/id16-4.png';

import p17_1 from '../images/products/id17/id17-1.png';
import p17_2 from '../images/products/id17/id17-2.png';
import p17_3 from '../images/products/id17/id17-3.png';
import p17_4 from '../images/products/id17/id17-4.png';

export const allProducts = [
  {
    id: 1,
    name: 'ALL NAVAGRAHA TEMPLES ARCHANA',
    images: [p1_1, p1_2, p1_3, p1_4],
    price: '8,999.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Navagraha Temples'],
    descriptionHtml:
      '<h4>Navagraha Temples Archana</h4>' +
      '<p>Sooriyan(Sun), Suryanaar Kovil, Chandran(Moon), Thingaloor; Chevai(Mars), Vaitheeswaran Kovil, Budhan(Mercury), Tiruvenpadu; Guru(Jupiter), Alongudi; Shukran(Venus), Kanjanur, Shani(Saturn), Tirunallar; Raahu, Tirunageswaram; Kethu, Keezhperumpallam;</p>' +
      '<ul>' +
      '<li>Navagrahas are the reason for all the good and bad happening in our life, so it\'s a must-do Archana periodically to get their blessings.</li>' +
      '<li>Our representative will do Archana for the Names & Star mentioned in all 9 Temples and send you the prasad via courier</li>' +
      '<li>To increase the trust, we are offering a live tracking service via WhatsApp, So you can track our representative geolocation lively.</li>' +
      '</ul>' +
      '<p className="special-note">We do Archana for the list of names you mentioned and send you prasad via courier. You can track our travel via WhatsApp live tracking.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 2,
    name: 'Surya Bhagavan Temple (Sun) - Suryanar Kovil',
    images: [p2_1, p2_2, p2_3],
    price: '2,799.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Surya Bhagavan Temple', 'Suryanar Kovil'],
    descriptionHtml:
      '<h4>Surya Bhagavan Temple (Sun) - Suryanar Kovil</h4>' +
      '<p>Special Archana performed at Suryanaar Kovil for your name and star, invoking Sooriyan’s blessings, with sacred prasad delivered safely to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Surya Dosha effects such as weak authority, health issues, career delays, and lack of recognition, strengthening Sun placement for confidence, leadership, stability, and positive life direction.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing purity, prosperity, health, and divine blessings.</li>' +
      '<li>Enhances health, vitality, confidence, career growth, leadership qualities, mental clarity, and success, while removing negativity and strengthening willpower, discipline, and overall positive energy in personal and professional life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed personally at the temple, names and stars chanted properly, live WhatsApp location tracking provided, prasad securely packed and couriered, ensuring transparency, devotion, trust, and a spiritually fulfilling experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 3,
    name: 'Chandran Bhagavan Temple (Moon) - Thingaloor',
    images: [p3_1, p3_2, p3_3],
    price: '2,799.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Chandran Bhagavan Temple', 'Moon', 'Thingaloor'],
    descriptionHtml:
      '<h4>Chandran Bhagavan Temple (Moon) - Thingaloor</h4>' +
      '<p>Special Archana performed at Thingaloor Chandran Temple for your name and star, seeking Moon’s blessings, emotional balance, mental peace, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Chandra Dosha effects such as emotional instability, anxiety, sleep disorders, relationship stress, and mental confusion, strengthening Moon placement for calmness, clarity, intuition, stability, and harmonious family and personal life.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, representing purity, emotional calm, mental balance, nourishment, and divine lunar blessings.</li>' +
      '<li>Improves emotional stability, mental peace, memory power, sleep quality, family harmony, and decision-making ability, while reducing stress, fear, mood swings, and enhancing intuition, compassion, and inner strength.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted as provided, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring transparency, devotion, reliability, and a spiritually satisfying experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 4,
    name: 'Guru Bhagavan Temple (Jupiter) - Alangudi',
    images: [p4_1, p4_2, p4_3],
    price: '2,299.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Guru Bhagavan Temple', 'Jupiter', 'Alangudi'],
    descriptionHtml:
      '<h4>Guru Bhagavan Temple (Jupiter) - Alangudi</h4>' +
      '<p>Special Archana performed at Alangudi Guru Temple for your name and star, seeking Jupiter’s blessings for wisdom, prosperity, growth, guidance, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Guru Dosha effects such as delays in marriage, financial instability, lack of guidance, education obstacles, and weak judgment, strengthening Jupiter placement for wisdom, prosperity, stability, spiritual growth, and positive life decisions.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing wisdom, prosperity, nourishment, spiritual clarity, and Guru Bhagavan’s divine blessings.</li>' +
      '<li>Enhances wisdom, education, wealth, marital harmony, career stability, spiritual growth, and decision-making power, while removing obstacles, confusion, delays, and attracting positive guidance, abundance, and long-term success in life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed personally at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad securely packed and couriered, ensuring devotion, transparency, reliability, trust, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 5,
    name: 'Budhan Bhagavan Temple (Mercury) - Tiruvengadu',
    images: [p5_1, p5_2, p5_3],
    price: '2,899.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Budhan Bhagavan Temple', 'Mercury', ' Tiruvengadu'],
    descriptionHtml:
      '<h4>Budhan Bhagavan Temple (Mercury) - Tiruvengadu</h4>' +
      '<p>Special Archana performed at Tiruvengadu Budhan Temple for your name and star, seeking Mercury’s blessings for intelligence, communication skills, learning ability, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Budha Dosha effects such as speech issues, learning difficulties, nervousness, business losses, and poor communication, strengthening Mercury placement for intellect, clarity, adaptability, analytical skills, confidence, and success in education and commerce.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing intelligence, clarity, calmness, balance, prosperity, and Budhan Bhagavan’s divine blessings.</li>' +
      '<li>Improves intelligence, memory, communication, business acumen, decision-making, and learning abilities, while reducing confusion, anxiety, misunderstandings, and enhancing analytical thinking, adaptability, confidence, and success in education, trade, and professional life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted correctly, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring transparency, devotion, reliability, trust, and a spiritually satisfying service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },

  {
    id: 6,
    name: 'Chevvai Bhagavan Temple (Mars) - Vaitheeswaran Kovil',
    images: [p6_1, p6_2, p6_3],
    price: '2,799.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Chevvai Bhagavan Temple', 'Mars', 'Vaitheeswaran Kovil'],
    descriptionHtml:
      '<h4>Chevvai Bhagavan Temple (Mars) - Vaitheeswaran Kovil</h4>' +
      '<p>Special Archana performed at Vaitheeswaran Kovil Chevvai Temple for your name and star, seeking Mars blessings for courage, health, strength, protection, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Chevvai Dosha effects such as marriage delays, relationship conflicts, accidents, anger issues, debts, and legal troubles, strengthening Mars placement for courage, stability, protection, harmony, discipline, and successful personal and professional outcomes.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing protection, strength, healing, courage, positivity, and Chevvai Bhagavan’s divine blessings.</li>' +
      '<li>Improves health, courage, discipline, marital harmony, career stability, and protection from accidents, while reducing anger, conflicts, obstacles, debts, and delays, promoting healing, resilience, and overall positive energy in life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed personally at the temple, names and stars chanted properly, live WhatsApp location tracking shared, prasad securely packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 7,
    name: 'Kethu Bhagavan Temple - Keezhperumpallam',
    images: [p7_1, p7_2, p7_3],
    price: '2,799.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Kethu Bhagavan Temple', 'Keezhperumpallam'],
    descriptionHtml:
      '<h4>Kethu Bhagavan Temple - Keezhperumpallam</h4>' +
      '<p>Special Archana performed at Keezhperumpallam Kethu Temple for your name and star, seeking Kethu blessings for spiritual clarity, protection, liberation, wisdom, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Kethu Dosha effects such as unexplained fears, detachment issues, sudden losses, confusion, and spiritual imbalance, strengthening Kethu placement for intuition, protection, enlightenment, inner stability, clarity, and freedom from negative karmic influences.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing spiritual protection, detachment, clarity, healing, positivity, and Kethu Bhagavan divine blessings.</li>' +
      '<li>Enhances spiritual growth, intuition, inner peace, and protection from hidden obstacles, while reducing fears, confusion, karmic disturbances, and sudden setbacks, guiding devotees toward clarity, wisdom, and liberation in life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually satisfying service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 8,
    name: 'Rahu Bhagavan Temple - Thirunageswaram',
    images: [p8_1, p8_2, p8_3],
    price: '1,499.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Rahu Bhagavan Temple', 'Thirunageswaram'],
    descriptionHtml:
      '<h4>Rahu Bhagavan Temple - Thirunageswaram</h4>' +
      '<p>Special Archana performed at Thirunageswaram Rahu Temple for your name and star, seeking Rahus blessings for protection, success, clarity, stability, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Rahu Dosha effects such as sudden obstacles, fear, anxiety, illusion, career instability, and relationship issues, strengthening Rahu placement for protection, confidence, clarity, courage, controlled ambition, and success despite uncertainties.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing protection, courage, stability, clarity, positivity, and Rahu Bhagavans powerful divine blessings.</li>' +
      '<li>Improves protection from sudden setbacks, mental strength, courage, career stability, and spiritual awareness, while reducing fears, confusion, illusions, negative influences, and enhancing resilience, clarity, and controlled ambition in life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed personally at the temple, names and stars chanted correctly, live WhatsApp location tracking shared, prasad securely packed and couriered, ensuring devotion, transparency, reliability, trust, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 9,
    name: 'Sani Bhagavan Temple (Saturn) - Thirunallar',
    images: [p9_1, p9_2, p9_3],
    price: '2,999.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Sani Bhagavan Temple', 'Saturn', 'Thirunallar'],
    descriptionHtml:
      '<h4>Sani Bhagavan Temple (Saturn) - Thirunallar</h4>' +
      '<p>Special Archana performed at Thirunallar Sani Temple for your name and star, seeking Saturns blessings for relief, discipline, stability, justice, endurance, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Sani Dosha effects such as long-term struggles, delays, financial stress, health issues, and mental pressure, strengthening Saturn placement for patience, discipline, stability, justice, resilience, karmic balance, and gradual sustainable success.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing endurance, protection, discipline, patience, healing, and Sani Bhagavans powerful divine blessings.</li>' +
      '<li>Brings relief from hardships, delays, and karmic burdens, improves patience, discipline, health, financial stability, career progress, and mental strength, while protecting from negative influences and guiding steady long-term success.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually satisfying service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 10,
    name: 'Sukran Bahavan Temple (Venus) - Kanjanur',
    images: [p10_1, p10_2, p10_3],
    price: '2,799.00',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Sukran Bahavan Temple', 'Venus', 'Kanjanur'],
    descriptionHtml:
      '<h4>Sukran Bahavan Temple (Venus) - Kanjanur</h4>' +
      '<p>Special Archana performed at Kanjanur Sukran Temple for your name and star, seeking Venus blessings for love, harmony, prosperity, creativity, comfort, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Sukran Dosha effects such as relationship conflicts, delayed marriage, financial imbalance, luxury-related stress, and lack of enjoyment, strengthening Venus placement for harmony, attraction, prosperity, creativity, happiness, and refined life pleasures.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu, sugar candy, dried fruits, and flower petals, symbolizing love, harmony, prosperity, beauty, comfort, positivity, and Sukran Bhagavan’s divine blessings.</li>' +
      '<li>Enhances love, marital harmony, creativity, wealth, comforts, artistic talents, and emotional happiness, while reducing relationship tensions, financial instability, dissatisfaction, and attracting peace, prosperity, balance, and refined pleasures in personal life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed personally at the temple, names and stars chanted correctly, live WhatsApp location tracking shared, prasad securely packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 11,
    name: 'Mahalingeswarar Temple',
    images: [p11_1, p11_2, p11_3, p11_4],
    price: '1,799.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Mahalingeswarar', 'Shiva'],
    descriptionHtml:
      '<h4>Mahalingeswarar Temple</h4>' +
      '<p>Special Archana performed at Mahalingeswarar Temple for your name and star, seeking Lord Shivas blessings for peace, protection, spiritual strength, harmony, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce planetary afflictions, karmic burdens, mental stress, health issues, and ancestral doshas, invoking Lord Shivas grace for balance, protection, spiritual clarity, inner strength, stability, and relief from prolonged difficulties.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, Bilva leaf prasadam, and dry prasadam like laddu or sugar candy, symbolizing purity, healing, protection, spiritual awakening, peace, and Lord Shivas divine blessings.</li>' +
      '<li>Brings peace of mind, good health, spiritual growth, family harmony, relief from obstacles, and protection from negative forces, while strengthening devotion, patience, inner stability, and positive transformation in personal and professional life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 12,
    name: 'Amirthakadeswarar Temple',
    images: [p12_1, p12_2, p12_3, p12_4],
    price: '2,699.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Amirthakadeswarar Temple', 'Shiva'],
    descriptionHtml:
      '<h4>Amirthakadeswarar Temple</h4>' +
      '<p>Special Archana performed at Amirthakadeswarar Temple for your name and star, seeking Lord Shiva’s blessings for healing, longevity, peace, protection, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce health-related afflictions, chronic issues, karmic blocks, mental stress, and planetary doshas, invoking Lord Shiva’s nectar-like grace for healing, balance, protection, stability, longevity, and spiritual well-being.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, Bilva leaf prasadam, and dry prasadam like laddu or sugar candy, symbolizing healing, purity, protection, longevity, peace, and Amirthakadeswarar’s divine blessings.</li>' +
      '<li>Promotes good health, healing from ailments, longevity, mental peace, spiritual growth, family harmony, and relief from suffering, while strengthening faith, patience, inner balance, and positive transformation in daily life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually satisfying service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 13,
    name: 'Sri Sarabeshwarar Temple',
    images: [p13_1, p13_2, p13_3, p13_4],
    price: '1,599.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Sri Sarabeshwarar Temple'],
    descriptionHtml:
      '<h4>Sri Sarabeshwarar Temple</h4>' +
      '<p>Special Archana performed at Sri Sarabeshwarar Temple for your name and star, seeking Lord Sarabeshwarar’s blessings for protection, courage, relief from obstacles, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce severe planetary afflictions, black magic fears, sudden obstacles, enemy troubles, and intense karmic effects, invoking Lord Sarabeshwarar’s fierce protective energy for courage, stability, fearlessness, balance, and divine safeguarding.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, Bilva leaf prasadam, and dry prasadam like laddu or sugar candy, symbolizing powerful protection, courage, purification, strength, and Sri Sarabeshwarar’s divine blessings.</li>' +
      '<li>Provides strong protection from negative forces, removes fear, obstacles, and enemy troubles, strengthens courage, confidence, mental resilience, spiritual power, and brings stability, peace, and divine security in life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 14,
    name: 'Jagannatha Perumal Temple',
    images: [p14_1, p14_2, p14_3, p14_4],
    price: '2,699.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Jagannatha Perumal'],
    descriptionHtml:
      '<h4>Jagannatha Perumal Temple</h4>' +
      '<p>Special Archana performed at Jagannatha Perumal Temple for your name and star, seeking Lord Vishnu’s blessings for protection, prosperity, harmony, devotion, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce planetary imbalances, life instability, mental stress, relationship issues, and karmic burdens, invoking Lord Vishnu’s grace for protection, balance, dharmic living, stability, clarity, peace, and sustained positive life progress.</li>' +
      '<li>Includes Tulasi prasadam, Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu or sugar candy, symbolizing purity, protection, prosperity, devotion, peace, and Jagannatha Perumal’s divine blessings.</li>' +
      '<li>Brings protection, prosperity, family harmony, spiritual growth, mental peace, and guidance, while removing obstacles, confusion, instability, and strengthening faith, devotion, righteous living, and steady progress in personal and professional life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 15,
    name: 'Nageswaraswamy Temple ',
    images: [p15_1, p15_2, p15_3, p15_4],
    price: '1,299.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Nageswaraswamy', 'Shiva'],
    descriptionHtml:
      '<h4>Nageswaraswamy Temple</h4>' +
      '<p>Special Archana performed at Nageswaraswamy Temple for your name and star, seeking Lord Shiva’s blessings for protection, health, strength, relief from doshas, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce Sarpa Dosha, Rahu–Ketu afflictions, ancestral karmic blocks, delays, fears, and health issues, invoking Nageswaraswamy’s grace for protection, balance, relief, stability, prosperity, and spiritual purification.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, Bilva leaf prasadam, and dry prasadam like laddu or sugar candy, symbolizing protection, healing, purification, strength, balance, and Nageswaraswamy’s divine blessings.</li>' +
      '<li>Provides relief from Sarpa Dosha and planetary afflictions, improves health, family harmony, fertility prospects, and mental peace, while removing obstacles, fears, and negative influences, ensuring protection and steady positive life progress.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 16,
    name: 'Prathyangira Devi Temple',
    images: [p16_1, p16_2, p16_3, p16_4],
    price: '1,799.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Prathyangira Devi'],
    descriptionHtml:
      '<h4>Prathyangira Devi Temple</h4>' +
      '<p>Special Archana performed at Prathyangira Devi Temple for your name and star, seeking Devi’s blessings for protection, courage, relief from fear, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce severe planetary afflictions, black magic effects, enemy troubles, fear, sudden obstacles, and karmic attacks, invoking Prathyangira Devi’s fierce protective energy for courage, stability, victory, and spiritual safeguarding.</li>' +
      '<li>Includes Vibuthi, Kumkum, Chandanam, turmeric, vermilion, flower prasadam, and dry prasadam like laddu or sugar candy, symbolizing protection, strength, purification, courage, and Devi’s divine blessings.</li>' +
      '<li>Provides powerful protection from negative forces, removes fear, enemy threats, and obstacles, strengthens courage, mental resilience, spiritual power, and ensures victory, confidence, and stability in personal and professional life.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
  {
    id: 17,
    name: 'Ramaswamy Temple',
    images: [p17_1, p17_2, p17_3, p17_4],
    price: '1,599.00',
    type: 'special_archana',
    reviewsCount: 22,
    productCode: 'EA-NGT-01',
    tags: ['Ramaswamy Temple'],
    descriptionHtml:
      '<h4>Ramaswamy Temple</h4>' +
      '<p>Special Archana performed at Ramaswamy Temple for your name and star, seeking Lord Rama’s blessings for righteousness, protection, harmony, courage, and sacred prasad delivered to your home.</p>' +
      '<ul>' +
      '<li>Helps reduce life obstacles, moral conflicts, relationship tensions, mental stress, and karmic challenges, invoking Lord Rama’s grace for dharma, discipline, clarity, courage, emotional balance, and steady righteous progress in life.</li>' +
      '<li>Includes Tulasi prasadam, Vibuthi, Kumkum, Chandanam, and dry prasadam like laddu or sugar candy, symbolizing devotion, purity, protection, harmony, peace, and Lord Rama’s divine blessings.</li>' +
      '<li>Enhances discipline, courage, family harmony, moral strength, leadership qualities, spiritual growth, and mental peace, while removing obstacles, confusion, and stress, guiding devotees toward righteous living and stable success.</li>' +
      '</ul>' +
      '<p className="special-note">Archana performed sincerely at the temple, names and stars chanted accurately, live WhatsApp location tracking shared, prasad carefully packed and couriered, ensuring devotion, transparency, trust, reliability, and a spiritually fulfilling service experience.</p>',
    reviews: [
      {
        author: 'Amaresan',
        date: '07/03/2023',
        rating: 5,
        text: 'Your company saved me a lot of time and money, I am happy with the archana.',
      },
      {
        author: 'Raja',
        date: '01/01/2023',
        rating: 5,
        text: 'This is my 4th time I am using your service, the service what you do is really good, I will really recommend to my friends',
      },
      {
        author: 'Abinav',
        date: '22/02/2023',
        rating: 5,
        text: 'Thanks, I will use it again.',
      },
      {
        author: 'Aarthi',
        date: '17/06/2022',
        rating: 5,
        text: 'My parents are great followers of your team, and really happy working with you all the time',
      },
      {
        author: 'Aakash',
        date: '11/06/2022',
        rating: 5,
        text: 'The service they do is really great, I will use them again',
      },
    ],
  },
];